import { IAssistanceActivities } from "@edp-models/funciona.model";

export interface ITechnicalAssistancesState {
    technicalAssistances: {
        data: IAssistanceActivities;
        lastAPIError: Error
    };
}

export const initialTechnicalAssistancesState: ITechnicalAssistancesState = {
    technicalAssistances: {
        data: null,
        lastAPIError: null
    }
};
